import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26d2ffac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab_content p-2 border-round" }

import { TabItemType } from "./TabItemType";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabItem',
  props: {
    item: {},
    active: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab cursor-pointer block", {
      'active bg-white px-1 text-black': _ctx.active,
      'text-white h-3rem p-1': !_ctx.active,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.item.label), 1)
  ], 2))
}
}

})